var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskCategoryTaxRelief(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2f7785;fill-opacity:0.68;}.cls-3{mask:url(#mask);}.cls-4,.cls-7{fill:#c1dee2;}.cls-5{fill:#d4a181;}.cls-10,.cls-11,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-6{fill:#191847;}.cls-8{fill:#b28b67;}.cls-9{fill:#2f3676;}.cls-10{fill:#5c63ab;}.cls-11{fill:#dde3e9;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 223,
    height: 140,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    className: "cls-1",
    width: 180,
    height: 140
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agevolazioni") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "agevolazioni"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-2",
    "data-name": "Mask"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 180,
    height: 140
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.87,49a42.36,42.36,0,0,0-10.62-1.4H137.58c-1.21,0-2.39.09-3.56.18,0-.06,0-.11,0-.18a21.5,21.5,0,1,1,43,0C177,48.08,176.89,48.53,176.87,49Zm-7.2,91a3.58,3.58,0,0,1-3.56-3.58V125.69H137.67v10.73a3.58,3.58,0,0,1-3.56,3.58H119.89a3.58,3.58,0,0,1-3.56-3.58v-18a35.46,35.46,0,0,1-7-7H98.56A3.58,3.58,0,0,1,95,107.81V79.19a3.58,3.58,0,0,1,3.56-3.57h6.55a35.89,35.89,0,0,1,8.31-11.74L109.22,47h7.11a21.15,21.15,0,0,1,16.23,7.67,34.43,34.43,0,0,1,5.11-.52h28.44A35.65,35.65,0,0,1,201,82.77h9.6a5.36,5.36,0,0,0,5.22-6.44A5.47,5.47,0,0,0,210.34,72h-.22a1.35,1.35,0,0,1-1.34-1.34V66.23a1.35,1.35,0,0,1,1.34-1.35,12.76,12.76,0,0,1,12.77,10.87,12.49,12.49,0,0,1-12.33,14.17h-8.89a35.69,35.69,0,0,1-14.22,28.46v18a3.58,3.58,0,0,1-3.56,3.58ZM126.5,90a3.5,3.5,0,1,0-3.5-3.5A3.52,3.52,0,0,0,126.5,90Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.21,31.64c2,3.68,1.73,13-.81,13.65-1,.26-3.18-.38-5.38-1.71l1.38,9.77H42.24l2.81-13.09a9.18,9.18,0,0,1-2.45-6.61C43.11,26.37,53.24,28,55.21,31.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-6",
    d: "M50.56,27.41c-1.08-.17-4-.3-4.51-.3-.34,0-.71.08-.91-.23a2.51,2.51,0,0,1-.15-1c-.06-.35-.14-.69-.23-1a10.36,10.36,0,0,0-1.08-2.75,8.46,8.46,0,0,0-4-3.64,12.94,12.94,0,0,0-6.1-.84,26.75,26.75,0,0,0-6.23,1.58,13.12,13.12,0,0,1-6.09.59c-2.08-.32-3.65-1.45-5.4-2.51a10,10,0,0,0-6-1.65A11.54,11.54,0,0,0,4.45,17.7a8.92,8.92,0,0,0-3.51,4,5.46,5.46,0,0,0,.5,5.54c1.83,2.38,5.22,3,8,2.94a15.59,15.59,0,0,0,4.78-.88A46.46,46.46,0,0,0,20,26.34a15.24,15.24,0,0,1,2.82-1.13,3.14,3.14,0,0,1,2.74.18A12.85,12.85,0,0,0,28.33,27a9.25,9.25,0,0,0,3.12.56,30.38,30.38,0,0,0,6.11-1.1,12.55,12.55,0,0,1,5.06-.36c.7.14,1.71.43,2,1.16-4.24.76-5.9,6-4.71,9.84.65,2.08,4.52,4.5,6,3.41,1-.69.38-1.6,0-2.19-.71-1.15-1-2.62.37-3.42,1.15-.69,2.35.94,2.37.94A14.5,14.5,0,0,0,53.55,32c1.85.11,2.13-1.11,1.69-2.1S52,27.66,50.56,27.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Seat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48,95.85a16,16,0,0,1,16,16V122a16,16,0,0,1-16,16H30a16,16,0,0,1-16-16V111.85a16,16,0,0,1,16-16Zm2.48,9.52H27.54a4,4,0,0,0-4,4h0v15.11a4,4,0,0,0,4,4H50.48a4,4,0,0,0,4-4h0V109.37a4,4,0,0,0-4-4Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "LegLower",
    className: "cls-8",
    d: "M97.71,136.3q-10-12.27-13.6-18.2c-4.06-6.77-7.38-12.79-8.42-15.09-2.5-5.48,5.75-8.05,7.61-5.49q4.24,5.81,18.1,36.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84,133.92,71.5,102.52C68.83,96.8,81.72,93,83.68,95.7c4.45,6,15,29.9,16.36,31.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lower-Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.75,127.62c2.43-3.54,11.27-15.47,16.08-20.4,1.39-1.42,2.74-2.78,4-4,3.8-3.76,11.36,2.57,7.57,6-9.43,8.55-23.2,20.1-24.35,21.12C52.45,131.74,49.23,129.85,50.75,127.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    className: "cls-6",
    d: "M48.05,129.86l3.86-6,6.19,3.57a42,42,0,0,0,8.59,11.64L66,140.23l-11.19-6.46L51.33,131l-.34.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.92,140l.34-7.14h7.14a42.13,42.13,0,0,0,13.26,5.78V140H101.74l-4.42-.68V140Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg-and-Butt",
    className: "cls-10",
    d: "M67,104.09q-15.56-2.53-20.83-3.46c-10-1.77-13-7.17-11.24-19h18.5q3.68,1.06,30.68,13.11c3.24,1.61,2.63,6.35,2,7.91q0,.11-16.38,28.07l-15.13-9.63L67,105.23Q67.54,104.24,67,104.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "cls-8",
    d: "M21,73.75l7,1.38Q17.45,94.72,16.69,95.89c-1.15,1.76-.08,5,.31,6.7-2.47.57-1.49-3.15-4.62-2.37-2.86.71-5.28,2.53-8,.07A1.06,1.06,0,0,1,5,98.56c2.78-1.2,6.9-3.46,7.56-4.34Q13.91,92.44,21,73.75ZM89.9,63.3l-.12.18h0l-.25.38c-1,1.42-1.75,2.84-1.36,3.33s1.7-.06,2.2.86q.51.9-6.41,2.18L74.73,77.3l-3.93-5,12.32-5.41A29.27,29.27,0,0,1,89.37,62C90,61.76,91,61.7,89.9,63.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Back",
    className: "cls-9",
    d: "M46.9,47.69l2.94-.51c6.4,6.21,9,21.14,13.28,23.11,4,1.87,9.76.06,16.55-2.38l2.09,4.65c-6.18,6.68-19.34,12.33-24.68,9.11C48.56,76.51,46.59,58.11,46.9,47.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-11",
    d: "M34.08,84.63h26c1.19,0,1-1.72.8-2.58-2-10-9.73-20.77-9.73-35l-7.5-1.17C37.45,55.86,35.31,68.14,34.08,84.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Front",
    className: "cls-9",
    d: "M46.15,45.88q10.1,34.43,5.57,45.89H28.3a85.21,85.21,0,0,1,3.19-17.26q-8,14.34-13.38,20.66L12.66,94.1q5.27-32.67,30.51-48.22Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskCategoryTaxRelief);
export default __webpack_public_path__ + "static/media/ask-category-tax_relief.928875bf7958001d2e6f4ecbd0359295.svg";
export { ForwardRef as ReactComponent };